import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LocalHeader = () => {
  function checkUrl(query) {
    const classes = `nav-link ${
      window.location.pathname?.indexOf(query) === -1 ? "" : "active"
    }`;
    return classes;
  }
  const history = useHistory();
  return (
    <div class="row">
      <div class="tab-section">
        <div class="nav nav-tabs" id="nav-tab">
          <ul class="nav nav-tabs">
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/qr-ordering/general");
                }}
                class={checkUrl("general")}
              >
                GENERAL
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/qr-ordering/menu-sequencing");
                }}
                class={checkUrl("menu-sequencing")}
              >
                MENU &amp; SEQUENCING
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/qr-ordering/qr-list");
                }}
                class={checkUrl("qr-list")}
              >
                QR LIST
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  history.push("/settings/pos/qr-ordering/history");
                }}
                class={checkUrl("history")}
              >
                HISTORY
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LocalHeader;
